<template>
  <button
    v-bind="$attrs"
    class="rounded-md py-1.5 font-semibold disabled:opacity-30 disabled:cursor-not-allowed px-2 outline-none transition-all duration-200 ease-in-out"
    :class="{
      'min-w-max': !lineBreak,
      'w-full': block,
      'bg-blue text-gray-300 hover:bg-blue-dark hover:text-white': color === 'primary',
      'bg-gray-400 hover:bg-blue hover:text-white' : color === 'secondary',
      'bg-gray-100 text-blue hover:text-blue-dark ring-1 ring-gray-400 hover:ring-blue' : color === undefined,
      'opacity-50': loading,
      '!py-0.5 px-1 text-sm': dense,
      'w-36': !dense
    }"
    :disabled="disabled || loading"
    :type="type ?? 'button'"
  >
    <div
      class="flex justify-center items-center"
      :class="lineBreak && 'w-full'"
    >
      <div :class="{ 'mr-1': $slots.icon || loading }">
        <CarvisSpinner
          v-if="loading"
          class="w-5 h-5"
        />
        <slot
          v-else
          name="icon"
        />
      </div>
      <span :class="lineBreak && 'text-wrap'">
        <slot />
      </span>
    </div>
  </button>
</template>

<script setup lang="ts">
defineProps<{
  color?: 'primary' | 'secondary'
  type?: 'submit'
  block?: boolean
  loading?: boolean,
  disabled?: boolean,
  dense?: boolean
  lineBreak?: boolean
}>()

</script>
